



















import { defineComponent } from '@vue/composition-api'

import PageView from '@/components/templates/h/common/order-pattern-setting-sii/PageView.vue'
import SettingImportModal from '@/components/templates/h/SettingImportModal.vue'
import {
  OrderPatternSettingSiiOutputCondition,
  OrderPatternSettingSiiExtractCondition,
  ColumnLabel,
} from '@/types/entities'
import {
  TemplateFile,
  ResourceType,
  Where,
  WhereOp,
  OrderBy,
  OrderByDirection,
  OrderByNullsOption,
  VUiPOrderPatternSettingSiisCountDocument,
} from '@/types/generated/graphql'
import {
  OUTPUT_COND_DELETE,
  OUTPUT_COND_ITEM,
  OUTPUT_COND_REDUCE_FORECAST_DAYS,
  OUTPUT_COND_STORE,
  SELECT_MAX_COUNT,
} from '@/utils/constant'
import { EXPORT_FILENAME } from '@/utils/constant'
import importExportHelper from '@/utils/importExportHelper'
import { addDayYMD } from '@/utils/mixin'
import { setWhereValue, setWhereValues } from '@/utils/searchConditionDef'
import Toast from '@/utils/toast'
const DEFAULT_OUTPUT_CONST = {
  storeOutput: [
    OUTPUT_COND_STORE.all,
    OUTPUT_COND_STORE.area,
    OUTPUT_COND_STORE.tanten,
  ],
  itemOutput: [OUTPUT_COND_ITEM.shobunrui],
  delOutput: [],
  reduceForecastDaysOutput: [
    OUTPUT_COND_REDUCE_FORECAST_DAYS.enabled,
    OUTPUT_COND_REDUCE_FORECAST_DAYS.disabled,
  ],
}
const DEFAULT_EXTRACT_CONST = {
  validDate: [addDayYMD(1), '2999-12-31'],
}

export default defineComponent({
  components: { PageView, SettingImportModal },
  layout: 'sidebar',
  created() {
    this.helper = new importExportHelper(this)
  },
  data() {
    return {
      defaultDateValue: DEFAULT_EXTRACT_CONST.validDate,
      resourceType: ResourceType.UiPOrderPatternSettingSii,
      templateFile: TemplateFile.UiPOrderPatternSettingSii_01,
      extractCondition: {
        validDate: DEFAULT_EXTRACT_CONST.validDate,
        stores: [],
        areas: [],
        vendors: [],
        shobunruis: [],
      },
      outputCondition: DEFAULT_OUTPUT_CONST,
      outputUseList: [
        {
          outputCondType: 'Item',
          displayItems: DEFAULT_OUTPUT_CONST.itemOutput,
          defaultSelected: DEFAULT_OUTPUT_CONST.itemOutput,
          disabledItems: DEFAULT_OUTPUT_CONST.itemOutput,
          isTanaPattern: false,
        },
        {
          outputCondType: 'Store',
          displayItems: [
            OUTPUT_COND_STORE.all,
            OUTPUT_COND_STORE.area,
            OUTPUT_COND_STORE.tanten,
          ],
          defaultSelected: DEFAULT_OUTPUT_CONST.storeOutput,
          disabledItems: [],
          isTanaPattern: false,
        },
        {
          outputCondType: 'Delete',
          displayItems: [OUTPUT_COND_DELETE.includeDelete],
          defaultSelected: DEFAULT_OUTPUT_CONST.delOutput,
          disabledItems: [],
          isTanaPattern: false,
        },
        {
          outputCondType: 'ReduceForecastDays',
          displayItems: [
            OUTPUT_COND_REDUCE_FORECAST_DAYS.enabled,
            OUTPUT_COND_REDUCE_FORECAST_DAYS.disabled,
          ],
          defaultSelected: DEFAULT_OUTPUT_CONST.reduceForecastDaysOutput,
          disabledItems: [],
          isTanaPattern: false,
        },
      ],
      totalCount: null,
      exportSpinner: false,
    }
  },
  methods: {
    changeExtractCondition(cond: OrderPatternSettingSiiExtractCondition) {
      this.extractCondition = cond
      console.log('changeExtractCondition', this.extractCondition)
      this.requestCount()
    },
    changeOutputCondition(cond: OrderPatternSettingSiiOutputCondition) {
      console.log('changeOutputCondition', cond)
      this.outputCondition = cond
      this.requestCount()
    },
    async requestCount() {
      this.exportSpinner = true
      this.totalCount = null
      if (this.checkRequired(false)) {
        try {
          const result = await this.$apollo.query({
            query: VUiPOrderPatternSettingSiisCountDocument,
            variables: { where: this._createWhere() },
          })
          const data = result.data.vUiPOrderPatternSettingSiis.totalCount
          this.totalCount = data.toString()
          this.exportSpinner = false
        } catch (e) {
          console.error(e)
          this.exportSpinner = false
          this.totalCount = '-'
        }
      } else {
        this.exportSpinner = false
        this.totalCount = '-'
      }
    },
    //　入力チェック
    checkRequired(showToast: boolean) {
      // 入力チェック開始
      let errMsg = []
      // 必須項目チェック
      if (
        !this.extractCondition.validDate[0] ||
        !this.extractCondition.validDate[1] ||
        (this.extractCondition.areas.length == 0 &&
          this.extractCondition.stores.length == 0 &&
          this.extractCondition.shobunruis.length == 0 &&
          this.extractCondition.vendors.length == 0)
      ) {
        errMsg.push({
          message: this.$i18n.t('error.requiredItemNotInput'),
        })
      }
      // 選択数上限チェック
      if (this.extractCondition.areasCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.areaStore'),
            selected: this.extractCondition.areasCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.storesCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.store'),
            selected: this.extractCondition.storesCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.shobunruisCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.shobunrui'),
            selected: this.extractCondition.shobunruisCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.vendorsCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.vendor'),
            selected: this.extractCondition.vendorsCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (errMsg.length) {
        if (showToast) {
          for (const msg of errMsg) {
            Toast.error(this, msg)
          }
        }
        // 入力チェックに引っかかった場合はエクスポートの要求を出さない
        return false
      }
      return true
    },
    /*********************************
     * 以下はインポートリクエスト用の処理
     *********************************/
    requestImport() {
      console.log('requestImport')
      this.$refs.settingImportModal.show()
    },
    /**
     * インポート開始処理
     */
    async importFileUpload(files: File[]) {
      console.log('importFileUpload', { files })
      this.helper.import({
        files: files,
        resourceType: this.resourceType,
        optionXlsx: { skipRows: 3 },
      })
    },
    /*********************************
     * 以下はエクスポートリクエスト用の処理
     *********************************/
    /**
     * エクスポート処理
     */
    //  async execExport(input: ExportCondition) {
    async requestExport() {
      if (this.checkRequired(true)) {
        const query = this._createQueryString()
        await this.helper.export({
          query,
          jmespathQuery:
            'data.vUiPOrderPatternSettingSiis.edges[].node | map(&merge(`{"__update": null}`, @), @)',
          templateFile: this.templateFile,
          filenameExport: EXPORT_FILENAME.order_pattern_setting_sii,
          columnLabelMapping: this._create_column_label_mapping(),
        })
      }
    },
    /**
     * ファイル抽出Queryを構築する
     */
    _createQueryString(): string {
      const where = this._createWhere()
      const orderBy = this._createOrderByStatement()
      const rowQuery = `
        query c {
          vUiPOrderPatternSettingSiis(
            where: ${this.helper.generateQueryWhereString(where)}
            orderBy: ${this.helper.generateQueryOrderByString(orderBy)}
          ) {
            edges {
              node {
                inactiveFlg
                storeApplyLevel
                storeApplyScope
                vUiMStoreApplyLevel{
                  storeApplyScopeName
                }
                vendorCd
                vendorCdName
                category1
                category1Name
                orderFlgMon
                orderFlgTue
                orderFlgWed
                orderFlgThu
                orderFlgFri
                orderFlgSat
                orderFlgSun
                multiWeekOrderFlg
                startDate
                endDate
                reduceForecastDaysFlg
                configuredFlg
                lastModifiedDatetime
                lastModifiedUserName
              }
            }
          }
        }
        `
      return this.helper.generateQueryString({
        rowQuery: rowQuery,
        resourceType: this.resourceType,
        where: where,
      })
    },
    /**
     * ファイル抽出QueryのOrderByパラメータを構築する
     */
    _createOrderByStatement(): OrderBy[] {
      return [
        {
          field: 'storeApplyLevel',
          direction: OrderByDirection.Desc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'storeApplyScope',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'vendorCd',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'category1',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'startDate',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'endDate',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
      ]
    },
    /**
     * ファイル抽出QueryのWhereパラメータを構築する
     */
    _createWhere() {
      const ITEM_SEARCH_CONDITION: Where[] = [
        // 有効日
        { field: ['startDate'], op: WhereOp.Le, value: [''] },
        { field: ['endDateNvl'], op: WhereOp.Ge, value: [''] },
        // 棚パターンの抽出条件
        {
          field: ['vUiMStoreApplyLevel/vUiPAreas/areaCd'],
          op: WhereOp.In,
          value: [''],
        },
        // 店舗の抽出条件
        {
          field: ['vUiMStoreApplyLevel/validStores/storeCd'],
          op: WhereOp.In,
          value: [''],
        },
        // 商品の抽出条件
        {
          field: ['category1'],
          op: WhereOp.In,
          value: [''],
        },
        // 発注先の抽出条件
        {
          field: ['vendorCd'],
          op: WhereOp.In,
          value: [''],
        },

        // 出力条件
        { field: ['storeApplyLevel'], op: WhereOp.In, value: [''] },
        { field: ['inactiveFlg'], op: WhereOp.In, value: [''] },
        { field: ['reduceForecastDaysFlg'], op: WhereOp.In, value: [''] },
        // 設定行フラグ　1固定
        { field: ['configuredFlg'], op: WhereOp.In, value: ['1'] },
      ]
      const where = JSON.parse(JSON.stringify(ITEM_SEARCH_CONDITION))
      setWhereValue(where, 'startDate', this.extractCondition.validDate[1])
      setWhereValue(where, 'endDateNvl', this.extractCondition.validDate[0])
      setWhereValue(
        where,
        'vUiMStoreApplyLevel/vUiPAreas/areaCd',
        this.extractCondition.areas
      )
      setWhereValue(
        where,
        'vUiMStoreApplyLevel/validStores/storeCd',
        this.extractCondition.stores
      )
      setWhereValue(where, 'category1', this.extractCondition.shobunruis)
      setWhereValue(where, 'vendorCd', this.extractCondition.vendors)
      setWhereValue(where, 'storeApplyLevel', this.outputCondition.storeOutput)
      setWhereValue(where, 'inactiveFlg', [
        '0', // 削除されていないデータは必ず出力する
        ...this.outputCondition.delOutput,
      ])
      setWhereValue(
        where,
        'reduceForecastDaysFlg',
        this.outputCondition.reduceForecastDaysOutput &&
        this.outputCondition.reduceForecastDaysOutput.length > 0
          ? this.outputCondition.reduceForecastDaysOutput
          : [
              OUTPUT_COND_REDUCE_FORECAST_DAYS.enabled,
              OUTPUT_COND_REDUCE_FORECAST_DAYS.disabled,
            ]
      )
      console.log({ where })
      return where
    },
    _create_column_label_mapping() {
      const columnLabelMapping: ColumnLabel[] = [
        {
          from: '__update',
          to: '',
        },
        {
          from: 'inactiveFlg',
          to: '',
        },
        {
          from: 'storeApplyLevel',
          to: '',
        },
        {
          from: 'storeApplyLevelName',
          to: '',
        },
        {
          from: 'storeApplyScope',
          to: '',
        },
        {
          from: 'vUiMStoreApplyLevel.storeApplyScopeName',
          to: '',
        },
        {
          from: 'vendorCd',
          to: '',
        },
        {
          from: 'vendorCdName',
          to: '',
        },
        {
          from: 'category1',
          to: '',
        },
        {
          from: 'category1Name',
          to: '',
        },
        {
          from: 'orderFlgMon',
          to: '',
        },
        {
          from: 'orderFlgTue',
          to: '',
        },
        {
          from: 'orderFlgWed',
          to: '',
        },
        {
          from: 'orderFlgThu',
          to: '',
        },
        {
          from: 'orderFlgFri',
          to: '',
        },
        {
          from: 'orderFlgSat',
          to: '',
        },
        {
          from: 'orderFlgSun',
          to: '',
        },
        {
          from: 'multiWeekOrderFlg',
          to: '',
        },
        {
          from: 'multiWeekOrderFlgDisp',
          to: '',
        },
        {
          from: 'startDate',
          to: '',
        },
        {
          from: 'endDate',
          to: '',
        },
        {
          from: 'reduceForecastDaysFlg',
          to: '',
        },
        {
          from: 'configuredFlg',
          to: '',
        },
        {
          from: 'lastModifiedDatetime',
          to: '',
        },
        {
          from: 'lastModifiedUserName',
          to: '',
        },
      ]
      console.log({ columnLabelMapping })
      return columnLabelMapping
    },
  },
})
